import { palette } from '../../theme';

export const styles = {
  innerWrapper: {
    width: '100%',
    height: '300px',
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  dayWrapper: {
    position: 'relative',
  },

  day: {
    width: '32px',
    height: '32px',
    fontSize: '14px',
    lineHeight: '18px',
    margin: '0 3px',
    color: 'inherit',
    padding: '0 !important',
  },

  customDayHighlight: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '2px',
    right: '2px',
    border: `1px solid ${palette.secondary.main}`,
    borderRadius: '4px',
  },

  nonCurrentMonthDay: {
    color: palette.text.disabled,
  },

  highlightNonCurrentMonthDay: {
    color: '#676767',
  },

  highlight: {
    background: palette.primary.main,
    color: palette.background.paper,
  },

  firstHighlight: {
    background: palette.primary.main,
    color: palette.background.paper,
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
  },

  endHighlight: {
    background: palette.primary.main,
    color: palette.background.paper,
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
  },
};
